import {openDialog} from 'platform/components';

import i18n from '@dms/i18n';

import {ReactivateUserModalContent, ReactivateUserModalProps} from './ReactivateUserModalContent';

export const openReactivateUserModal = (data: ReactivateUserModalProps) =>
  openDialog(<ReactivateUserModalContent {...data} />, {
    title: i18n.t('entity.reActivateDialog.title'),
  });
